export function WarningIcon() {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_162_1508"
                // style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="22"
                height="22"
            >
                <path d="M22 0H0V22H22V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_162_1508)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00775 2.04323C9.89432 0.541092 12.1058 0.541091 12.9924 2.04323L21.6882 16.7772C22.603 18.3272 21.4168 20.1666 19.696 20.1666H2.30415C0.583312 20.1666 -0.602888 18.3272 0.311864 16.7772L9.00775 2.04323ZM9.22038 6.46747C9.19123 5.94204 9.60942 5.49996 10.1357 5.49996H11.8643C12.3906 5.49996 12.8088 5.94204 12.7796 6.46747L12.4231 12.8842C12.3961 13.3699 11.9943 13.75 11.5078 13.75H10.4922C10.0057 13.75 9.60392 13.3699 9.57688 12.8842L9.22038 6.46747ZM12.8333 16.5C12.8333 17.5125 12.0126 18.3333 11 18.3333C9.98745 18.3333 9.16667 17.5125 9.16667 16.5C9.16667 15.4874 9.98745 14.6666 11 14.6666C12.0126 14.6666 12.8333 15.4874 12.8333 16.5Z"
                    fill="#7F57C2"
                />
            </g>
        </svg>
    )
}
